import { RestApiClient } from 'ifield-core-components'
import _ from 'lodash'

/**
 * 文字列テンプレート取得
 * @returns {Array.<Object>} データ
 */
const getTextTemplates = async () => {
  const url = RestApiClient.createApiUrl('text_template')
  const json = await RestApiClient.executeGetApi(url)
  return json.data
}

/**
 * 初期スロットル間隔(ms)
 */
const INITIAL_THROTTLE_TIME = 30000

export default {
  namespaced: true,
  state: {
    textTemplates: [],
    usageOrders: [],
    throttleTime: INITIAL_THROTTLE_TIME,
    throttler: null,
  },
  persistentStates: ['throttleTime', 'usageOrders'],
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      state.textTemplates = []
      state.orders = []
      state.throttleTime = INITIAL_THROTTLE_TIME
      state.throttler = null
    },
    /**
     * 文字列テンプレートを設定する
     * @param {*} state
     * @param {Array.<Object>} textTemplates 文字列テンプレート
     */
    setTextTemplates(state, textTemplates) {
      state.textTemplates = textTemplates
    },
    /**
     * 使用順を設定する
     * @param {*} state
     * @param {Array.<Number>} orders 使用順ID配列
     */
    setUsageOrders(state, orders) {
      state.usageOrders = orders
    },
    /**
     * スロットル間隔を保存する
     * @param {*} state
     * @param {Number} time スロットル間隔(ms)
     */
    setThrottleTime(state, time) {
      state.throttleTime = +time
    },
    /**
     * スロットル関数を保存する
     * @param {*} state
     * @param {Function} throttler スロットル関数
     */
    setThrottler(state, throttler) {
      state.throttler = throttler
    },
  },
  getters: {
    /**
     * 文字列テンプレート
     * @param {*} state
     * @returns {Array.<Object>}
     */
    textTemplates: (state) => state.textTemplates,
    /**
     * 文字列テンプレート(ソート済み)
     * @param {*} state
     * @returns {Array.<Object>}
     */
    sortedTextTemplates: (state) =>
      [...state.textTemplates].sort((a, b) => {
        const indexA = state.usageOrders.findIndex((id) => id === a.id)
        const indexB = state.usageOrders.findIndex((id) => id === b.id)
        if (indexA === -1 && indexB === -1) {
          return a.sort_order - b.sort_order
        } else if (indexA === -1) {
          return 1
        } else if (indexB === -1) {
          return -1
        } else {
          return indexA - indexB
        }
      }),
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * 文字列テンプレートを更新する
     */
    async updateTextTemplates({ commit }) {
      const textTemplates = await getTextTemplates()
      commit('setTextTemplates', textTemplates)
    },
    /**
     * 文字列テンプレートを更新する(スロットル)
     */
    async updateTextTemplatesWithThrottle({ state, commit, dispatch }) {
      if (!state.throttler) {
        const throttler = _.throttle(
          () => dispatch('updateTextTemplates'),
          state.throttleTime,
          { trailing: false }
        )
        commit('setThrottler', throttler)
      }
      return state.throttler()
    },
    /**
     * スロットル間隔更新
     * @param {Number} time スロットル間隔(ms)
     */
    updateThrottleTime({ commit }, time) {
      commit('setThrottleTime', +time)
      commit('setThrottler', null)
    },
    /**
     * 対象IDのテンプレートを一番前に移動する
     * @param {Number} id 対象ID
     */
    moveFirst({ state, commit }, id) {
      const orders = [...state.usageOrders]
      const index = orders.findIndex((templateId) => templateId === id)
      if (index !== -1) {
        orders.splice(index, 1)
      }
      orders.unshift(id)

      commit('setUsageOrders', orders)
    },
  },
}
